import { SettlementExtent } from '@mews-commander/data-access';
import { EnumSelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { getTimeClass } from '@mews-commander/utils';
import { WithEnterpriseId } from '@mews-commander/types';
import { CurrencySelectField } from '../../../../../components/form/hookFields';
import { SettlementConfigurationsFieldName } from '../types';
import { useCurrentServiceIdContext } from '../../../contexts';
import { useSelectedService } from '../hooks/useSelectedService';
import { PaymentConfigurationOptionsField } from './PaymentConfigurationOptionsField';
import { MaximumTimeForPaymentField } from './MaximumTimeForPaymentField';

export interface SettlementConfigurationFieldsProps extends WithEnterpriseId {
    currencyScope?: 'all' | 'currentEnterprise';
    currencyFieldIsDisabled?: boolean;
    delayAutoFocus?: boolean;
}

export const SettlementConfigurationFields = ({
    currencyScope = 'currentEnterprise',
    currencyFieldIsDisabled = false,
    delayAutoFocus = false,
    enterpriseId,
}: SettlementConfigurationFieldsProps) => {
    const serviceId = useCurrentServiceIdContext();
    const service = useSelectedService({ enterpriseId, serviceId });

    return (
        <>
            <MaximumTimeForPaymentField
                name={SettlementConfigurationsFieldName.MaximumTime}
                autoFocus={!delayAutoFocus}
                timeUnit={service ? getTimeClass(service) : undefined}
            />
            <EnumSelectField
                enumClass={SettlementExtent}
                enumPrefix="SettlementExtent"
                required
                label={lt('SettlementExtent')}
                name={SettlementConfigurationsFieldName.Extent}
                multiselect
                omitHint
            />
            <PaymentConfigurationOptionsField name={SettlementConfigurationsFieldName.Options} />
            <CurrencySelectField
                required
                currencyScope={currencyScope}
                disabled={currencyFieldIsDisabled}
                name={SettlementConfigurationsFieldName.CurrencyCode}
                label={lt('Currency')}
            />
        </>
    );
};
